import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { t } from '../i18n/index.js';
import { currentTheme, nextTheme, setThemePref } from './theme.js';

/** Dark / light toggle (system → light → dark cycle), shared by both apps. */
export function ThemeToggle() {
  const [theme, setTheme] = useState(currentTheme());
  useEffect(() => {
    const on = () => setTheme(currentTheme());
    window.addEventListener('siva:theme', on);
    return () => window.removeEventListener('siva:theme', on);
  }, []);
  const label = theme === 'dark' ? t('theme_light') : t('theme_dark');
  return (
    <button
      type="button"
      className="icon-btn"
      onClick={() => void setThemePref(nextTheme())}
      aria-label={label}
      title={label}
    >
      {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
